import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getPAIAF020, postMAKAB020 } from '../../../services/Api';
import SideNav from '../../../shared/components/SideNav';
import Messages from '../../../shared/components/Messages';

const PAIAF020 = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const messagesEndRef = useRef(null);
    const [contents, setContents] = useState('');

    const handleChange = (e) => {
        setContents(e.target.value);
    };

    const getListData = () => {
        getPAIAF020(id)
            .then(({ data }) => {
                data && setData(data.reverse());
            })
            .catch((error) => console.log(error));
    };

    const groupMessagesByDate = (messages) => {
        if (!Array.isArray(messages)) return {};

        return messages.reduce((acc, msg) => {
            const messageDate = moment(msg.sendDate).format('YYYY-MM-DD');

            if (!acc[messageDate]) {
                acc[messageDate] = [];
            }
            acc[messageDate].push(msg);
            return acc;
        }, {});
    };

    const groupedMessages = groupMessagesByDate(data);

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
        }
        if (data && data.length > 0 && data[0].type === 'RECEIVED') {
            data[0].toMemberId = data[0].fromMemberID;
        } else if (data && data.length > 0 && data[0].type === 'SEND') {
            data[0].toMemberId = data[0].toMemberID;
        }
    }, [data]);

    const handleSubmit = () => {
        if (contents.trim() === '') {
            window.alert('모든 정보를 입력해 주세요.');
            return;
        }
        const payload = {
            toMemberId: data.length > 0 ? data[0].toMemberId : '',
            readed: 'N',
            title: data.length > 0 ? data[0].title : '',
            contents: contents,
            tblName: 'propose',
            revDel: 'N',
            sendDel: 'N',
            topic: id,
        };

        postMAKAB020(payload)
            .then(() => {
                window.alert('쪽지가 성공적으로 전송되었습니다.');
                setContents('');
                getListData();
            })
            .catch((error) => {
                console.log(error);
                window.alert('쪽지 전송에 실패하였습니다.');
            });
    };
    return (
        <div id="content" className="sub-page">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="resume">
                        <div className="resume__inner" style={{ paddingBottom: '40px' }}>
                            <h3 className="resume__tit">쪽지</h3>
                            <div className="rsm-mng__btbx">
                                <Link to="/paiaf010" className="rsm-mng__btn rsm-mng__btn--wd120">
                                    쪽지 목록
                                </Link>
                            </div>

                            <div className="msg__container">
                                <div className="msg__view" ref={messagesEndRef}>
                                    <Messages groupedMessages={groupedMessages} />
                                    <div ref={messagesEndRef}></div>
                                </div>
                            </div>
                            <div className="msg__ans">
                                <textarea
                                    className="msg__textarea"
                                    placeholder="텍스트를 입력하세요. (100자 이내)"
                                    value={contents}
                                    onChange={handleChange}
                                    maxLength={100}
                                />
                                <button type="button" className="msg__send-btn" onClick={handleSubmit}>
                                    보내기
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* End resume */}
                </div>
                {/* End Top Sub Page */}
            </div>
        </div>
    );
};

export default PAIAF020;
